import { getRequestQueryKey } from '../../hooks/use_suspense_api'

export const getFeaturesRequestArgs = () => {
  const url = '/me/features'

  return {
    url,
    data: {
      perPage: 100,
      fields: {
        Feature: ['name', 'enabled'],
      },
    },
  }
}

export const getFeaturesQueryKey = () => {
  const requestArgs = getFeaturesRequestArgs()
  return getRequestQueryKey(requestArgs)
}
